// extracted by mini-css-extract-plugin
export var NewsItemForm = "NewsItemForm-module--NewsItemForm--rlqWX";
export var column = "NewsItemForm-module--column--s1Wv7";
export var error = "NewsItemForm-module--error--sPQGg";
export var fieldset = "NewsItemForm-module--fieldset--rnBD-";
export var formControl = "NewsItemForm-module--formControl--d8-Cz";
export var formFeedback = "NewsItemForm-module--formFeedback--rlpvo";
export var row = "NewsItemForm-module--row--6xDJA";
export var small = "NewsItemForm-module--small---BjAg";
export var wide = "NewsItemForm-module--wide--gxFEC";